<template>
    <div class="layout-wrapper" @mouseleave="handleMouseOut">
        <BaseHeader></BaseHeader>
        <div class="height-box"></div>
        <router-view />
        <BaseFooter></BaseFooter>
        <Call></Call>
        <MessageAlert v-show="alert" @close="close"></MessageAlert>
    </div>
</template>
<script>
import BaseHeader from '@/components/BaseHeader.vue'
import BaseFooter from '@/components/BaseFooter.vue'
import Call from '@/components/Call.vue'
import MessageAlert from '@/components/MessageAlert.vue'

export default {
    components: { BaseHeader, BaseFooter, Call, MessageAlert },
    data() {
        return {
            alert: false,
            closeMessage: false,
			
        }
    },
    watch: {
        '$route'(to, from) {
            this.alert = false
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 可选，实现平滑滚动
            });
        }
    },
    // mounted() {
    //     window.addEventListener('mouseout', this.handleMouseOut);
    // },
    // beforeDestroy() {
    //     window.removeEventListener('mouseout', this.handleMouseOut);
    // },
    methods: {
        close() {
            this.alert = false
        },
        handleMouseOut() {
			let ifshow = this.$getStorage('ifshow');
			if (!ifshow){
				this.alert = true
				this.$setStorage('ifshow',true); 
			}
            
        }
    }
}
</script>
<style lang="scss" scoped>
.height-box {
    height: 0.8rem;
    width: 100%;
}

.layout-wrapper {
    width: 100%;
}

@media (max-width: 750px) {
    .height-box {
        height: 1.6rem;
        width: 100%;
    }


}
</style>